/**
 * Conversation Persistence Types
 *
 * These types define the structure for persisting conversations to disk.
 * They are designed to be FULLY COMPATIBLE with the in-memory structures in:
 * - ThreadState (from core/types.ts)
 * - ChatMessage (from llm/baseAdapter.ts)
 * - Conversation (from global-state/globalStateManager.ts)
 * - ContextResolver storage (from core/contextResolver.ts)
 *
 * IMPORTANT: When loading from disk, these structures can be directly
 * used to restore the in-memory state without transformation.
 */
// ═══════════════════════════════════════════════════════════════════════════
// CONSTANTS
// ═══════════════════════════════════════════════════════════════════════════
/** Current schema version */
export const PERSISTENCE_SCHEMA_VERSION = '1.0.0';
/** Folder name for conversations within the DB path */
export const CONVERSATIONS_FOLDER = 'conversations';
/** Index file name */
export const INDEX_FILE_NAME = 'index.json';
/** File extension for conversation files */
export const CONVERSATION_FILE_EXTENSION = '.json';
